import { render, staticRenderFns } from "./LinhaFormulario.vue?vue&type=template&id=a29229de"
import script from "./LinhaFormulario.vue?vue&type=script&lang=js"
export * from "./LinhaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports